import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FileUploader } from 'ng2-file-upload';
import { HomeService } from '../home/home.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-blackliste',
  templateUrl: './blackliste.component.html',
  styleUrls: ['./blackliste.component.css']
})
export class BlacklisteComponent implements OnInit {


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns1 = ['id', 'civilite','delete'];

  uploadForm:FormGroup
  public uploader:FileUploader = new FileUploader({
    isHTML5: true
  });

  constructor(private _service:HomeService, private _formBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.uploadForm = this._formBuilder.group({
      document: [null, null]
    });
    this.blackListe();
  }
  listFiche
  listResult
  blackListe(){
    this._service.getFicheBlack().subscribe(e=>{
      this.listFiche= e;
      this.listResult = this.listFiche;
      this.listResult = new MatTableDataSource(this.listResult);
    
   
      this.listResult.paginator = this.paginator;
      this.listResult.sort = this.sort;
  
      console.log(this.listFiche)
    })
  
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.listResult.filter = filterValue;

  }



  data1
  isOk:boolean;
  uploadSubmit(){

    for (let i = 0; i < this.uploader.queue.length; i++) {
      let fileItem = this.uploader.queue[i]._file;
      if(fileItem.size > 90000000){
        alert("Taille du fichier doit être inférieure à  90 MB.");
        return;
      }
      console.log(this.uploader.queue[i]._file)
    }
    for (let j = 0; j < this.uploader.queue.length; j++) {
      let data = new FormData();
      let fileItem = this.uploader.queue[j]._file;
      
      data.append('file', fileItem);
      data.append('fileSeq', 'seq'+j);
    //  data.append('id',this.id_file);
    
    // this.uploadFile(data).subscribe(data => alert(data.message));
    this._service.uploadBlack(data).subscribe(data=>{
       console.log(data)
       this.data1= data;
       if(this.data1.status =="fichier invalide !"){
        this.isOk =false;
        setTimeout(()=>{                           //<<<---using ()=> syntax
          this.isOk = null;
     }, 5000);
       }else{
        this.isOk =true;
        setTimeout(()=>{                           //<<<---using ()=> syntax
          this.isOk = null;
     }, 5000);
       }
   
     },error=>{
      this.isOk =false;
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.isOk = null;
   }, 5000);
     })

    }
   
    this.uploader.clearQueue();
    this.data = [];
    this.dataExel = null;

  }

  onFileChange(evt: any) {
    const target : DataTransfer =  <DataTransfer>(evt.target);
    
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;

      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname : string = wb.SheetNames[0];

      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      console.log(ws);

      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));

      console.log(this.data);
      this.convertToArrayOfObjects(this.data);

      let x = this.data.slice(1);
      console.log(x);

    };

    reader.readAsBinaryString(target.files[0]);

  }
  data: [][];
  convertToArrayOfObjects(data) {
    var keys = data.shift(),
    
        i = 0, k = 0,
        obj = null,
        output = [];
       

    for (i = 0; i < data.length; i++) {
        obj = {};

        for (k = 0; k < keys.length; k++) {
            obj["num"] = data[i][k];
        }

        output.push(obj);
    }
    
    console.log(output)
    this.dataExel = output;
    this.dataExel = JSON.parse(JSON.stringify(this.dataExel).replace(/\s(?=\w+":)/g, ""));
    this.dataExel = JSON.parse(JSON.stringify(this.dataExel).replace(/-/g, ""));
    console.log(this.dataExel)
    return output;
}
dataExel
effacer(){
  this.dataExel = null;
}

dataDelete:string[] = [];
idSelect
dataGid = {
  ids:[]
}

toggle(event){
  this.idSelect = event;
  this.dataDelete.push(this.idSelect.toString())
  this.dataGid = {
    ids : this.dataDelete
  }
  console.log(this.dataGid)

}
supprimer(){
  if(this.dataDelete.length ==0){
    return
  }
  if(confirm("confirmer la supression ?") == true){
    this._service.deleteByGid(this.dataGid).subscribe(data=>{
      console.log(data)
    })  }else{
    console.log('no')
  }
}
}
